module.exports = __webpack_public_path__ + "img/md-git-pull-request.4a5595be.svg";